<div (click)="openSupport()" class="buttonBall support" id="FormSupportButton">
    <div class="buttonLabel">HELP</div>
</div>
